import React from "react";
import clsx from "clsx";
import MenuBuilder from "../../MenuBuilder/MenuBuilder";

class PropertyDetailsBuilderMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var menuClasses = clsx({
      active: this.props.active_tab == "menu",
      "tab-pane": true,
    });

    return (
      <div className={menuClasses} id="menu">
        <div className="row">
          <div className="col-md-12">
            <MenuBuilder
              menu_items={this.props.menu_items}
              onChangeMenuItemStatus={this.props.onChangeMenuItemStatus}
              onChangeMenuItemName={this.props.onChangeMenuItemName}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default PropertyDetailsBuilderMenu;
